import { TutorialStep } from "..";

export const InspHistogramSteps: TutorialStep[] = [
  {
    target: "#insp-histogram",
    content: `저장된 검사 모델이 있다면, \n 그 모델을 통해 검증된 결과를 그래프로 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#histogram-zoom-btn",
    content: `돋보기 버튼을 클릭하여 크게 확인하세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#histogram-modal",
    content: `score별 이미지의 라벨 결과입니다.\n그래프를 클릭하여 상세데이터를 확인하세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  // ponytail: placeholder content, fill in when this step's copy is written
  {
    target: "#score-img-list",
    content: "",
    disableOverlayClose: true,
  },
  // ponytail: placeholder content, fill in when this step's copy is written
  {
    target: "#selected-score-img",
    content: "",
    disableOverlayClose: true,
  },
];
